import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/audit-logs"); setLogs(data || []); })(); }, []);
  return (
    <AppLayout title="Audit Log" subtitle="Admin activity">
      <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
        <table className="data-table">
          <thead><tr><th>When</th><th>Actor</th><th>Action</th><th>Details</th></tr></thead>
          <tbody>
            {logs.map(l => (
              <tr key={l.id}>
                <td className="font-mono text-xs">{new Date(l.created_at).toLocaleString()}</td>
                <td className="font-mono text-xs">{l.actor_id.slice(0,8)}</td>
                <td><b>{l.action}</b></td>
                <td className="font-mono text-xs text-slate-500 max-w-md truncate">{JSON.stringify(l.details)}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={4} className="text-center py-8 text-slate-500">No audit logs yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
